import React from 'react'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { monokai } from 'react-syntax-highlighter/dist/esm/styles/hljs'

const CodeBlock = ({ _node, inline, className, children, ...props }) => {
  const match = /language-(\w+)/.exec(className || '')

  const renderInlineCode = () => (
    <code
      {...props}
      className={className}
      style={{
        backgroundColor: '#eee',
        color: '#222',
        padding: 4,
        borderRadius: 3,
        fontWeight: 'bold',
        fontSize: 'inherit',
      }}
    >
      {children}
    </code>
  )

  if (inline || !match) return renderInlineCode()

  return (
    <SyntaxHighlighter
      {...props}
      style={monokai}
      language={match[1]}
      PreTag="div"
    >
      {String(children).replace(/\n$/, '')}
    </SyntaxHighlighter>
  )
}

export default CodeBlock
